import { modifier } from 'ember-modifier';

// Scrolls an element into view
// If the element is already in the view it does nothing
interface NamedArgs extends Record<string, unknown> {
  parentQuerySelector?: string; // querySelector for parent element. must be present
}

export default modifier(
  (el: HTMLElement, _posParams: [], namedArgs: NamedArgs = {}) => {
    let parentEl = el.closest(namedArgs.parentQuerySelector!);
    if (parentEl) {
      if (
        parentEl.scrollTop > el.offsetTop - el.clientHeight ||
        parentEl.clientHeight + parentEl.scrollTop < el.offsetTop
      ) {
        setTimeout(() => {
          el.scrollIntoView(false);
        });
      }
    }
  },
);
